<template>
  <section>
    <!--Not showing seasons-->
    <template v-if="!showSeasons">
      <v-btn x-small outlined color="primary" class="ma-1 py-4 px-2" elevation="0"
        v-for="league in leagues"
        :key="league.id"
        :class="buttonClasses(league)"
        :value="league.id"
        @click="$emit('leagueClicked', league)"
      >
        <img contain class="me-2" height="16"
          :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${league.id}.png`"
          @error="onImageLoadFailure"
        />
        <span v-if="league.label" class="font-weight-bold">{{ league.label }}</span>
        <v-badge tile dot color="green"
          v-if="league.seasonActive"
          offset-y="-8"
          offset-x="-0.4"
        ></v-badge>
      </v-btn>
    </template>

    <!--Show seasons-->
    <template v-else>
      <v-menu :key="league.id" bottom rounded offset-y v-for="league in leagues">
        <template v-slot:activator="{ on, attrs }">
          <v-btn x-small outlined color="primary" class="ma-1 py-4 px-2" elevation="0"
            :class="buttonClasses(league)"
            :value="league.id"
            v-bind="attrs"
            v-on="on"
          >
            <img contain class="me-2" height="16"
              :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${league.id}.png`"
              @error="onImageLoadFailure"
            />
            <span v-if="league.label" class="font-weight-bold">{{ league.label }}</span>
            <v-badge tile dot color="green"
              v-if="league.seasonActive"
              offset-y="-8"
              offset-x="-0.4"
            ></v-badge>
          </v-btn>
        </template>
        <v-list rounded dense>
          <v-list-item
            v-for="(year, index) in league.years"
            :key="index"
            @click="$emit('yearClicked', { year, league })"
          >
            <v-list-item-content>
              <v-list-item-title>{{ year }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </section>
</template>

<script>
export default {
  name: 'LeagueSimpleTab',
  props: {
    leagues: {
      type: Array,
      default: () => [],
      required: true,
    },
    showSeasons: {
      type: Boolean,
      default: false,
      required: false
    },
    showActiveStyle: {
      type: Function,
      required: false
    }
  },
  methods: {
    buttonClasses(league) {
      const isActive = this.showActiveStyle && this.showActiveStyle(league);
      const dark = this.$vuetify.theme.dark;
      return {
        'grey lighten-1': isActive && !dark,
        lightSecondary: isActive && dark,
        'black lighten-3': dark && !isActive,
        'grey lighten-4': !dark && !isActive
      };
    },
    onImageLoadFailure(event) {
      event.target.src = "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png";
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/league/league-selector/LeagueSimpleTab.vue